import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Form from '../../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../../components/Form/FormItem'
import Select from '../../../components/Inputs/Select'
import Datepicker from '../../../components/Inputs/Datepicker'
import InputNumber from '../../../components/Inputs/InputNumber'
import { IoMdAdd } from 'react-icons/io'
import { dateToDB } from '../../../utils/utils'

const server = process.env.REACT_APP_SERVER_URL

const ReturnForm : React.FC<IReturnForm> = ({onAddReturn}) => {
  const [accounts, setAccounts] = useState<any[]>([])

  const [selectedAccount, setSelectedAccount] = useState<any | null>(null)

  const form = useForm()

  const getAccounts = async (): Promise<void> => {
    let response = await axios.get(`${server}/finances/account`)
    setAccounts(response.data.accounts)
    let { accounts } = response.data
    setSelectedAccount({
      text: accounts[0]?.description,
      value: accounts[0]?.id,
    })
  }

  useEffect(() => {
    getAccounts()
  }, [])

  return (
    <Form form={form} classes="gap-x-3" onSubmit={() => null}>
      <FormItem
        name="account"
        classes="xl:col-span-7 xl:mb-4 xl:mt-0 col-span-12 mt-5"
        rules={{ required: 'Es necesario una descripcion' }}
      >
        <Select
          label="Cuenta"
          value={selectedAccount}
          options={accounts?.map((v) => ({
            text: v?.description,
            value: v?.id,
          }))}
          onChange={(values) => {
            setSelectedAccount(values)
          }}
        />
      </FormItem>

      <FormItem name="date" classes="xl:col-span-5 xl:mb-4 col-span-12 mt-1">
        <Datepicker label="Fecha" />
      </FormItem>

      <FormItem name="amount" classes="xl:col-span-4 xl:mb-4 col-span-12 mt-1">
        <InputNumber label="Monto" addDecimals={true} />
      </FormItem>

      <FormItem
        name="reference"
        classes="xl:col-span-4 xl:mb-4 col-span-12 mt-1"
      >
        {/* <InputText label="Referencia" /> */}
        <label className="font-medium text-primary-900 text-xs dark:text-white">
          Referencia
        </label>
        <input
          ref={form.register}
          className="cursor-text transition w-full dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
          type="text"
        />
      </FormItem>

      <div className="col-span-4 flex flex-row items-center" onClick={() => {
        setSelectedAccount({ text: accounts[0]?.description, value: accounts[0]?.id })
        console.log("accounts", accounts)
        let account : any = accounts.find(v => v.id === form.getValues()?.account)
        onAddReturn({...form.getValues(), date: dateToDB(form.getValues().date) ,account: {id: form.getValues().account, name: account?.description, currency: account?.idCurrency}})
        form.setValue('amount', '')
        form.setValue('reference', '')
      } } >
        <IoMdAdd className="text-primary" />
        <u className="text-primary text-xs cursor-pointer lg:my-5">Añadir Reembolso</u>
      </div>
    </Form>
  )
}

interface IReturnForm {
  onAddReturn: (values) =>  void
}

export default ReturnForm
